import ringRedIcon from 'assets/images/icons/ring-red.svg';
import ringBlueIcon from 'assets/images/icons/ring-blue.svg';
import ringYellowIcon from 'assets/images/icons/ring-yellow.svg';

export const generateTextWithSuffix = (items, showCount = 1, suffix, fallback, translateVal) => {
  // suffixFormat ==> (count)=> ` +${count} more`
  if (!items?.length) {
    return translateVal && fallback ? translateVal(fallback) : fallback ?? '';
  }
  const len = items.length;
  if (len <= showCount) return items.join(', ');
  // Build visible items
  let result = '';
  for (let i = 0; i < showCount; i++) {
    if (result) result += ', ';
    result += items[i];
  }
  // Only append suffix if provided
  if (suffix) {
    const remaining = len - showCount;
    const suffixText = typeof suffix === 'function' ? suffix(remaining) : suffix;
    result += suffixText;
  }
  return result;
};

export const getDisplayValueFromList = (list, value, defaultValue) => {
  return list.find((o) => o.value === value)?.displayValue ?? defaultValue;
};

export const priorityOptionsList = [
  { value: 'low', displayValue: 'select_low', icon: ringBlueIcon },
  { value: 'medium', displayValue: 'select_medium', icon: ringYellowIcon },
  { value: 'high', displayValue: 'select_high', icon: ringRedIcon },
];

export const displayISOTo12HourString = (isoString) => {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';

  let hours = date.getHours();
  const minutes = date.getMinutes();

  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  const hourStr = hours.toString().padStart(2, '0');
  const minuteStr = minutes.toString().padStart(2, '0');

  return `${hourStr}:${minuteStr} ${period}`;
};
